//import logo from './logo.svg';
import './App.css';
import Dashboard from './components/Dashboard';
import React, { useState } from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';
import { useEffect } from 'react';

function App() {
  // Track if Keycloak has already been initialized
  const [initialized, setInitialized] = useState(false);

  const handleOnEvent = (event, error) => {
    console.log('onKeycloakEvent', event, error);
    if (event === 'onReady') {
      setInitialized(true);
    }
    if (event === 'onInitError') {
      console.error('Keycloak initialization error:', error);
      // If it's just an iframe timeout, try to continue anyway
      if (error && error.error === 'Timeout when waiting for 3rd party check iframe message.') {
        console.log('Iframe timeout detected, attempting to continue...');
        setInitialized(true);
      }
    }
  };
  useEffect(() => {
    // Clear any previous Keycloak data
    localStorage.removeItem('kc-callback');
    localStorage.removeItem('kc-login-form');

    // Find and clear any keys related to your realm/client
    Object.keys(localStorage).forEach(key => {
      if (key.includes('keycloak') || key.includes('interPED')) {
        localStorage.removeItem(key);
      }
    });
  }, []);
  return (

    <ReactKeycloakProvider authClient={keycloak}
      onEvent={handleOnEvent}
      initOptions={{
        onLoad: 'login-required',
        checkLoginIframe: false,
        pkceMethod: 'S256',
        enableLogging: true,
        tokenStorage: 'sessionStorage',
        responseMode: 'query',
        flow: 'standard',
        redirectUri: window.location.origin + '/'
      }}>
      {initialized ? <Dashboard /> : <div>Loading authentication...</div>}
    </ReactKeycloakProvider>
  );
}

export default App;
